import { render } from "./customPopup.vue?vue&type=template&id=232a474d"
import script from "./customPopup.vue?vue&type=script&lang=js"
export * from "./customPopup.vue?vue&type=script&lang=js"

import "./customPopup.vue?vue&type=style&index=0&id=232a474d&lang=scss&scpoed=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__